/*import glslify from 'glslify';
//import * as PIXI from 'pixi.js';
const PIXI = window.PIXI;
export class CRT extends PIXI.Filter
{
  constructor()
  {
    super(glslify('../fragments/default.vert'),
          glslify('./crt.frag'));
  }
}*/

const PIXI = window.PIXI;
// create filter

/*var fragSrc = `

precision mediump float;
varying vec2 vTextureCoord;
uniform sampler2D uSampler;
uniform vec2 dimensions;
uniform vec4 filterArea;
uniform float iGlobalTime;


const float PI = 3.1415926535897932384626433832795;

#define HORIZONTAL_RESOLUTION 400.0
#define VERTICAL_RESOLUTION 220.0


vec3 getCrtCoord(vec2 screenPos, float size, float bend){
    float xd = screenPos.x - 0.5;
    float yd = screenPos.y - 0.5;

    float x = screenPos.x + xd * pow(abs(yd),bend);
    float y = screenPos.y + yd * pow(abs(xd),bend);

    return vec3(x,y,size);
}

vec3 getColorText(vec2 pos){
    float vPos = floor(VERTICAL_RESOLUTION    * pos.y);
    float hPos = floor(HORIZONTAL_RESOLUTION * pos.x);

    float x = hPos / HORIZONTAL_RESOLUTION;
    float y = vPos / VERTICAL_RESOLUTION;

    if (x<0.0 || x>1.0 ||y<0.0||y>1.0)
        return vec3(0,0,0);
    else
        return texture2D(uSampler,vec2(x,y),-16.0).xyz;
}

vec3 getLinearColorText(vec2 pos){
    float vPos = floor(VERTICAL_RESOLUTION    * pos.y);
    float hPos = floor(HORIZONTAL_RESOLUTION * pos.x);
    float hFra = fract(HORIZONTAL_RESOLUTION * pos.x);


    float xa = (hPos-1.0) / HORIZONTAL_RESOLUTION;
    float xb =  hPos      / HORIZONTAL_RESOLUTION;
    float y = vPos / VERTICAL_RESOLUTION;

    if (xa<0.0||xa>1.0||xb<0.0||xb>1.0||y<0.0||y>1.0)
        return vec3(0,0,0);
    else{
        vec3 ca = texture2D(uSampler,vec2(xa,y),-16.0).xyz;
        vec3 cb = texture2D(uSampler,vec2(xb,y),-16.0).xyz;
        return mix(ca,cb,hFra);
    }
}

#define BLUR_W  3
#define BLUR_H  3

vec3 blur(vec2 pos,vec2 size){
    float g[9];
    g[0]=0.077847; g[1]=0.123317; g[2]=0.077847;
	g[3]=0.123317; g[4]=0.195346; g[5]=0.123317;
	g[6]=0.077847; g[7]=0.123317; g[8]=0.077847;

    vec3 ret = vec3(0,0,0);

    for (int x=0;x<BLUR_W;x++){
        for (int y=0;y<BLUR_H;y++){
            ret += g[x+y*BLUR_W] * getColorText(pos+vec2(x-BLUR_W/2,y-BLUR_H/2)*size);
        }
    }
	return ret;
}

void main()
{
    vec3 coord = getCrtCoord(vTextureCoord,1.5/length(dimensions.xy),2.5);

    vec3 color  = getColorText(coord.xy);
    vec3 lcolor = getLinearColorText(coord.xy);
    vec3 bcolor = blur(coord.xy,vec2(1.0/HORIZONTAL_RESOLUTION,1.0/VERTICAL_RESOLUTION));

    // Cromatic Distortion
    vec2 rdist   = vec2(10.0 * sin(iGlobalTime),0)*coord.z;
    vec2 gdist   = vec2(0,10.0 * sin(iGlobalTime))*coord.z;
    vec2 bdist   = vec2(-10.0 * sin(iGlobalTime),0)*coord.z;
    vec3 dcolor = vec3(0,0,0);
    dcolor.x    = getColorText(coord.xy + rdist).x;
    dcolor.y    = getColorText(coord.xy + gdist).y;
    dcolor.z    = getColorText(coord.xy + bdist).z;

    float luminance  = (0.2126*lcolor.x + 0.7152*lcolor.y + 0.0722*lcolor.z);

    // Basic Shadowmask
    float mx = mod(floor(vTextureCoord.x + vTextureCoord.y/2.0),3.0);
    vec3 shadowMask = vec3(1.0,1.0,1.0);

#if 1
    // CMY
    if (mx == 0.0) shadowMask = vec3(1.0,1.0,luminance);
    if (mx == 1.0) shadowMask = vec3(luminance,1.0,1.0);
    if (mx == 2.0) shadowMask = vec3(1.0,luminance,1.0);
# else
    // RGB
    if (mx == 0.0) shadowMask = vec3(1.0,luminance,luminance);
    if (mx == 1.0) shadowMask = vec3(luminance,1.0,luminance);
    if (mx == 2.0) shadowMask = vec3(luminance,luminance,1.0);
#endif

    // ScanLine
    //
		//I'm using Cos to generate the scanline
		//considering the pixel height I'm trying to
		//calculate the area below the sin function.
		//Integral ( Cos(x) + 1 dx ) = Sin(x) + x + C


    float sa = PI + 2.0*PI*( (coord.y-0.0) * VERTICAL_RESOLUTION );
    float sb = PI + 2.0*PI*( (coord.y+coord.z*2.0) * VERTICAL_RESOLUTION );
    float sinFunc = 0.5 * (
        (sin(sb) + sb ) -
        (sin(sa) + sa ) ) / (sb - sa);
    float minScanline = pow(sinFunc,luminance);
    float maxScanline = pow(sinFunc,0.1);
    float scanline = pow(sinFunc,mix(10.0,0.001,luminance));
    // Tests
    //gl_FragColor = vec4( scanline * color,1.0);
    //gl_FragColor = vec4(luminance,luminance,luminance,1.0);
    //gl_FragColor = vec4(scanline,scanline,scanline,1.0);
    //gl_FragColor = vec4(shadowMask * scanline,1.0);
    //gl_FragColor = vec4(scanline * dcolor * color,1.0);
    //gl_FragColor = vec4(bcolor,1.0);
    // gl_FragColor = vec4(shadowMask * scanline * color + pow(bcolor,vec3(4,4,4)) ,1.0);
    gl_FragColor = vec4(scanline * dcolor + pow(bcolor,vec3(4,4,4)) ,1.0);
}
`.split('\n').reduce( (c, a) => c + a.trim() + '\n' );*/



var fragSrc = `
  precision mediump float;
  varying vec2 vTextureCoord;
  uniform sampler2D uSampler;
  uniform vec2 dimensions;
  uniform vec4 filterArea;
  uniform float iGlobalTime;

  const float PI = 3.1415926535897932384626433832795;

  float rand(vec2 co, float seed)
  {
    return fract(sin(dot(co.xy ,vec2(12.9898 + seed,78.233 - seed))) * 43758.5453);
  }

  float rn(float xx)
  {
    float x0=floor(xx);
    float x1=x0+1.0;
    float v0 = fract(sin (x0*.014686)*31718.927+x0);
    float v1 = fract(sin (x1*.014686)*31718.927+x1);

    return (v0*(1.0-fract(xx))+v1*(fract(xx)))*2.0-1.0*sin(xx);
  }

  float random(vec2 p, float t){return fract(cos(dot(p,vec2(23.14069263277926, t)))*sin(t));}


  vec3 getColorText(vec2 pos){
      float vPos = floor(240.0    * pos.y);
      float hPos = floor(120.0 * pos.x);

      float x = hPos / 240.0;
      float y = vPos / 120.0;

      if (x<0.0 || x>1.0 ||y<0.0||y>1.0)
          return vec3(0,0,0);
      else
          return texture2D(uSampler,vec2(x,y),-16.0).xyz;
  }


  vec4 scanline(vec2 coord, vec4 screen)
  {
    screen.rgb -= sin((coord.y + (iGlobalTime * 1.0)) / 0.5);
  	return screen;
  }

  vec4 sampleSplit(vec2 coord)
  {
    vec4 frag;
    frag.r = texture2D(uSampler, vec2(coord.x - 0.001 * length(coord) / 1.0, coord.y)).r;
    frag.g = texture2D(uSampler, vec2(coord.x                          , coord.y)).g;
    frag.b = texture2D(uSampler, vec2(coord.x + 0.001 * length(coord) / 1.0, coord.y)).b;
    return frag;
  }

  void main()
  {

    vec2 uv = vec2(vTextureCoord.x, vTextureCoord.y);
    float xdist = (.35 - uv.x)*2.;
    //float ydist = (.5 - uv.y)*2.;
    float ydist = uv.y;
    float dist = 1. - sqrt(xdist*xdist/2. + ydist*ydist/2.);

    float deEffect = 2.0;
    vec2 lensShift = uv + vec2(xdist*dist/deEffect, 0);
    lensShift.x = clamp(lensShift.x, 0.0, 1.0);
    lensShift.y = clamp(lensShift.y, 0.0, 1.0);


    float t = iGlobalTime;
    vec4 colorLens = sampleSplit(lensShift);
    //vec4 colorLens = texture2D(uSampler, uv);

    colorLens /= 5.0;
    gl_FragColor = colorLens;
}

`.split('\n').reduce( (c, a) => c + a.trim() + '\n' );

var CRT = new PIXI.Filter( null, fragSrc );
CRT.time = 0;
CRT.apply = function(filterManager, input, output)
{
  this.uniforms.dimensions[0] = input.sourceFrame.width
  this.uniforms.dimensions[1] = input.sourceFrame.height
  this.uniforms.iGlobalTime = this.time / 1000.0;
  // draw the filter...
  filterManager.applyFilter(this, input, output);
}

export default CRT;



// WEBPACK FOOTER //
// ./src/filters/crt/pixi_CRT.js